<script lang="ts" setup>
import { computed, ref, toRefs, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import config from '@/config';
import { useRouter, useRoute } from 'vue-router';
import { startFromTop } from '@/utils';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();

const route = useRoute();
const props = withDefaults( 
    defineProps<{
        modelValue: number;
        offset: number;
        limit: number;
        total?: number;
        forceMobile?:boolean
    }>(), 
    {total: 0, forceMobile: false}
);

const { limit, offset, total, modelValue: page, forceMobile } = toRefs(props);
const emit = defineEmits(['update:modelValue']);

const next = () => {
    if (page.value > totalPages()) {
        return;
    }
    emit('update:modelValue', page.value + 1);
};

const previous = () => {
    if (page.value === 1) {
        return;
    }
    emit('update:modelValue', page.value - 1);
};

const setPage = (page: number) => {
    emit('update:modelValue', page);
};

const totalPages = () => {
    return Math.ceil(total.value / limit.value);
};

const pages = computed(() => {
    const pages = [];
    const indexStart = ((offset.value / limit.value) + 1) - 2;
    const indexEnd = ((offset.value / limit.value) + 1) + 2;

    for (var paged = indexStart; paged <= indexEnd; paged++) {
        if (paged < 1 || paged > Math.ceil(total.value / limit.value)) {
            continue;
        }

        pages.push(paged);
    }

    return pages;
});

const showPrevious = () => {
    startFromTop();
    return offset.value > 0;
};

const showNext = () => {
    startFromTop();
    return total.value > offset.value + limit.value;
};

const useMobile = computed( ()=> props.forceMobile || userStore.isMobile() )
</script>

<template src="./pager.html"></template>

<style lang="scss">
@import './pager.scss';
</style>
